const settings = {
  // url: 'http://10.1.1.72'
  // url: 'http://www.digifarma.com'
  url: '',
  urlRelatorios:'http://webgestor.digifarma.com.br' 
}
export default settings

